const mutations = {
  getCustomerListId: (state, customer_list_id) => {
    state.customer_list_id = customer_list_id;
  },

};

export default mutations;
